export const LOGOUT_ACTION = 'LOGOUT_ACTION';
export const REGISTER_ACTION = 'REGISTER_ACTION';
export const SIGN_IN_ACTION = 'SIGN_IN_ACTION';
export const SIGN_UP_ACTION = 'SIGN_UP_ACTION'; // volunteer sign-up
export const GET_VOLUNTEER_INFO = 'GET_VOLUNTEER_INFO';
export const DELETE_VOLUNTEER_ACTION = 'DELETE_VOLUNTEER_ACTION';
